module.exports = __webpack_public_path__ + "img/photo-0125.53d40a2e.jpg";